/* eslint-disable max-len */
import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import SplitPane from 'react-split-pane';
import { useLocalStorage } from 'react-use';
import styled from 'styled-components';
import { cieq, useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { Icon } from '../../concepts/resources/Icon';
import { Fill } from '../../ui/Fill';
import { FadeIn } from '../../ui/Transitions';
import { VerticalTabSet } from '../../ui/VerticalTabSet';
import { UseLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { UserRole } from '../PassportModel';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Crumbs } from '../common/Crumbs';
import { Page } from '../common/Page';
import { FlexFrame, Spacer } from '../dashboard/elements/LayoutElements';
import { PopupManager } from '../popups/PopupManager';
import { Colors, remInPx } from './../../ui';
import { accountInvitePopup } from './AccountInvitePopup';
import { ManageUsersDetailView } from './ManageUsersDetailView';
import { ManageUsersModel, ManageUsersScope } from './ManageUsersScope';

const XScrollbars = Scrollbars as any;
const XSplitPane = SplitPane as any;

const RoleBadge = styled.div<{ roleName: string }>`
    position: relative;
    top: .1rem;
    margin-right: 1em;
    font-size: .675rem;
    font-weight: 450;
    padding: .2rem .25rem .1rem;
    border-radius: .3rem;
    color: white;
    text-align: center;
    ${p => p.roleName === 'account_owner' ? `background: ${Colors.mystery}` : ''};
    ${p => p.roleName === 'account_admin' ? `background: ${Colors.primary}` : ''};
    ${p => p.roleName === 'account_member' ? `background: ${Colors.positive};` : ''};
    ${p => p.roleName === 'account_guest' ? `background: ${Colors.gray500};` : ''};
`;

const ManageUsersLayout: LFC<{ param?: string }> = ({ param }) => {

    const [leftSize, setLeftSize] = useLocalStorage('deqo/ui/people/leftSize', remInPx(20));
    const users = useObserver(useResolve(ManageUsersModel));
    const selected = users.find(x => cieq(x.id, param)) ?? users[0];

    const popups = useResolve(PopupManager);
    const onInvitePeople = () => popups.invoke(accountInvitePopup());

    return <Fill flex="column">
        <FlexFrame>
            <VerticalTabSet>
                <XSplitPane className="flex" split="vertical" minSize={remInPx(12)} size={leftSize} maxSize={remInPx(30)} onChange={setLeftSize}>
                    <VerticalTabSet.Menu expand>
                        <VerticalTabSet.Button onClick={onInvitePeople}>
                            <Icon size="1.2" src="deqo://icons/hero/user-add" />&nbsp;&nbsp;Invite People
                        </VerticalTabSet.Button>
                        <Spacer />
                        <XScrollbars autoHide>
                            {users.map(x =>
                                <VerticalTabSet.Link key={x.id} to={`~/manage/people/${x.id}`} selected={x === selected}>
                                    <RoleBadge roleName={x.roleName}>
                                        {UserRole.lookup(x.roleName)?.badge}
                                    </RoleBadge>
                                    {x.name}
                                </VerticalTabSet.Link>
                            )}
                        </XScrollbars>
                    </VerticalTabSet.Menu>
                    <VerticalTabSet.Content>
                        <FadeIn key={param}>
                            <ManageUsersDetailView key={selected.id} user={selected} />
                        </FadeIn>
                    </VerticalTabSet.Content>
                </XSplitPane>
            </VerticalTabSet>
        </FlexFrame>
    </Fill>;
};

export const ManageUsersView: LFC<{ param?: string }> = (props) => {
    return <ManageUsersScope>
        <UseLocationScope name="users" label="People" />
        <Page.Header>
            <Crumbs items={[
                ['Manage', '/manage'],
                ['People', null],
            ]} />
            <Page.HeaderPush>
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Page.HeaderPush>
        </Page.Header>
        <Page.Content>
            <ManageUsersLayout {...props} />
        </Page.Content>
    </ManageUsersScope>;
};

